/* eslint-disable no-redeclare */
import { z } from 'zod';

export const DrivingHistory = z.enum(['YES', 'NO']);

export type DrivingHistory = z.infer<typeof DrivingHistory>;
